import { statusMeta } from "../lib/constants";

export function StatusBadge({ list, value, onClick, testid }) {
  const m = statusMeta(list, value);
  return (
    <span data-testid={testid} onClick={onClick}
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${onClick ? "cursor-pointer" : ""}`}
      style={{ background: m.color, color: m.text }}>
      {m.label}
    </span>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6">
      <div>
        <h1 className="font-head text-2xl sm:text-3xl font-extrabold tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {children && <div className="flex flex-wrap gap-2">{children}</div>}
    </div>
  );
}

export function EmptyState({ title, hint }) {
  return (
    <div className="card-soft p-10 text-center">
      <p className="font-medium">{title}</p>
      {hint && <p className="text-sm text-muted-foreground mt-1">{hint}</p>}
    </div>
  );
}

export function Stat({ label, value, tone = "default", testid, onClick }) {
  const tones = {
    default: "text-foreground", brand: "text-brand", danger: "text-destructive", green: "text-emerald-600",
  };
  return (
    <div className={`card-soft p-4 lift ${onClick ? "cursor-pointer hover:ring-2 hover:ring-brand/40 transition-shadow" : ""}`} data-testid={testid} onClick={onClick} role={onClick ? "button" : undefined}>
      <p className="text-xs uppercase tracking-wide text-muted-foreground font-medium">{label}</p>
      <p className={`font-head text-2xl font-extrabold mt-1 ${tones[tone]}`}>{value}</p>
      {onClick && <p className="text-[11px] text-brand mt-1">Apri e gestisci →</p>}
    </div>
  );
}
